/* eslint-disable functional/no-conditional-statement */

import { colorsSideEffects } from "./colorsSideEffects";
import { SettingsState } from "./settingsAtom";

export function setColors(settingsResult: SettingsState) {
  const rootStyle = document?.querySelector<HTMLElement>(":root")?.style;

  const sideEffects = colorsSideEffects(settingsResult);
  if (sideEffects !== "initializing") {
    if (sideEffects.primaryArguments !== "skip") {
      rootStyle?.setProperty(...sideEffects.primaryArguments);
    }
    if (sideEffects.secondaryArguments !== "skip") {
      rootStyle?.setProperty(...sideEffects.secondaryArguments);
    }
  }
}
